(() => {
  const root = document.documentElement;
  if (!root.hasAttribute('data-cs-mode') || window.CSThemeMode) return;
  const key = root.dataset.csModeKey;
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let manual = root.dataset.csModeManual === 'true';
  let timer;
  const defaultMode = () => root.dataset.csModeDefault === 'system' ? (media.matches ? 'dark' : 'light') : root.dataset.csModeDefault;
  const sync = () => {
    const dark = root.dataset.theme === 'dark';
    document.querySelectorAll('[data-cs-theme-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', dark ? button.dataset.labelLight : button.dataset.labelDark);
    });
  };
  const set = (mode, persist = false, animate = false) => {
    if (mode !== 'light' && mode !== 'dark') return;
    clearTimeout(timer);
    root.classList.remove('cs-mode-changing');
    if (animate && !motion.matches) {
      root.classList.add('cs-mode-changing');
      void root.offsetWidth;
      timer = setTimeout(() => root.classList.remove('cs-mode-changing'), 400);
    }
    if (persist) {
      manual = true;
      try { localStorage.setItem(key, mode); } catch (_) {}
    }
    root.dataset.csModeManual = String(manual);
    root.dataset.theme = mode;
    root.style.colorScheme = mode;
    sync();
    document.dispatchEvent(new CustomEvent('cs:theme-mode-change', { detail: { mode, manual } }));
  };
  window.CSThemeMode = Object.freeze({ get: () => root.dataset.theme, set: mode => set(mode, true, true) });
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-cs-theme-toggle]') : null;
    if (button) set(root.dataset.theme === 'dark' ? 'light' : 'dark', true, true);
  });
  media.addEventListener('change', () => { if (!manual && root.dataset.csModeDefault === 'system') set(defaultMode()); });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    manual = event.newValue === 'light' || event.newValue === 'dark';
    set(manual ? event.newValue : defaultMode());
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      try {
        const saved = localStorage.getItem(key);
        manual = saved === 'light' || saved === 'dark';
        set(manual ? saved : defaultMode());
      } catch (_) { sync(); }
    } else sync();
  });
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
